/*
 * @Description: 封装请求js
 * @Date: 2024-05-07 14:24:00
 * @LastEditors: function
 * @LastEditTime: 2025-07-22 10:32:12
 * @FilePath: \protal-web\src\utils\request.js
 */
import axios from 'axios'
import { calculationSign, decrypt } from '@/utils/sign'

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'

const service = axios.create({
  timeout: 50000,
  baseURL: '/apis'
})

service.interceptors.request.use(
    config => {
      if (localStorage.getItem('token')) {
        config.headers['Authorization'] = localStorage.getItem('token')
      }
      if (config.method === 'get') {
        config.params = config.params || {}
      }
      const isPro = window.sessionStorage.getItem('api_status') || 'true'
      if (config.method === 'post' && config.url.indexOf('fileserv/v1/upload') === -1) { // 参数加密
        config = isPro === 'true' ? calculationSign(config) : config
      }
      return config
    },
    error => {
      console.error(error)
      return Promise.reject(error)
    }
)

service.interceptors.response.use(
    response => {
      const { responseURL } = response.request
      if (responseURL.includes('/download') || response.request.responseType === 'blob') return response// 文件流 直接返回
      let res = null
      if (response.data.code || response.data.message === "success") {
        res = response.data
      } else {
        res = JSON.parse(decrypt(response.data))
      }
      // console.log(res, '解密数据')
      if (res.code !== '00000' && res.status !== 0) {

        return Promise.reject(new Error(res.message || 'Error'))
      } else {
        return res
      }
    },
    error => {
      let message = ''
      if (error.response) {
        if (error.response.data) {
          if (error.response.data.message) {
            message = error.response.data.message
          } else {
            message = error.response.data
          }
        } else {
          message = error.response
        }
      } else {
        message = error
      }

      console.error('err' + message) // for debug
      return Promise.reject(message)
    }
)

export default service
